import React from 'react'
import KitchenConfigSection from './KitchenConfigSection'

interface Props {
  locationId: number
  kitchenConfigurationOptions: Record<string, { rows: number, columns: number }>
  canUpdateLocation: boolean
  onDirtyChange?: (dirty: boolean) => void
}

const Status = ({ locationId, kitchenConfigurationOptions, canUpdateLocation, onDirtyChange }: Props) => (
  <div className="py-3">
    <KitchenConfigSection
      locationId={locationId}
      kitchenConfigurationOptions={kitchenConfigurationOptions}
      canUpdateLocation={canUpdateLocation}
      onDirtyChange={onDirtyChange}
    />
  </div>
)

export default Status
